import { Block, useBlockRenderer } from '@/hooks/use-block-renderer'
import { BlockRenderer } from '@/Components/block-renderer'

export default function Community() {
  const blocks = useBlockRenderer('community') as Block[]

  return <BlockRenderer blocks={blocks} />
}
